import { VStack } from "Components";
import ZCMsg from "Components/ZChat/ZCMsg/ZCMsg";
import { backendConnector, DATA_LINK } from "connectors";
import { useEffect, useState } from "react";
import { v1 } from "uuid";

export function ConversationHistory({ doc, period }: any) {
  const [history, setHistory] = useState<any[]>([]);

  useEffect(() => {
    async function getHistory(session_id: string) {
      const res = await backendConnector.post(
        DATA_LINK.GPTConvList,
        {
          selector: {
            $and: [
              {
                session_id: {
                  $eq: session_id,
                },
              },
            ],
          },
        },
        period
      );

      const prev = res?.payload?.docs;
      prev?.sort((a: any, b: any) => new Date(a.CREATED_AT).getTime() - new Date(b.CREATED_AT).getTime());

      setHistory(prev);
    }
    if (doc?.session_id) getHistory(doc.session_id);
  }, [doc.session_id]);
  if (!doc?.session_id) return <></>;

  const opacity = 1;

  return (
    <VStack sx={{ width: "100%" }}>
      {history.map((o) => {
        const input = {
          msg: {
            text: o.answer,
          },
        };

        const output = {
          msg: {
            text: o.question,
          },
        };

        // Show border if the conversation log is selected
        const borderWidth = o._id === doc._id ? 2 : 0;

        return (
          <VStack
            sx={{
              width: "100%",
              border: `${borderWidth}px solid`,
              borderImage: "linear-gradient(to bottom right, rgba(0, 95, 115, 0.3) , rgba(0, 95, 115, 1))",
              borderImageSlice: 1,
            }}
            key={v1()}
          >
            <ZCMsg
              cssp="zchat z"
              key={v1()}
              _onQuickReply={() => {}}
              pos={"out"}
              item={output}
              last={true}
              typingBubbles={false}
              showQuickRepliesAsButtons={true}
              HTMLEnabled={true}
              opacity={opacity}
            />
            <ZCMsg cssp="zchat z" key={v1()} _onQuickReply={() => {}} pos={"in"} item={input} last={true} typingBubbles={false} showQuickRepliesAsButtons={true} HTMLEnabled={true} opacity={opacity} />
          </VStack>
        );
      })}
    </VStack>
  );
}
